import React from "react";
import CustomTable from "../customTable";
import { ResultsPerListAndCampaignsColumns } from "./columns/ResultsPerListAndCampaignsColumns";
import Comments from "../comments";

const ResultsPerListAndCampaign = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerListAndCampaignsColumns}
        data={processedData?.results_per_list_and_campaigns?.data || []}
        totalAggregatedData={processedData?.results_per_list_and_campaigns?.totals || {}}
        loading={loading}
        storageKey={"resultsperlistandcampaign"}
      />
      <Comments tab_name="Results per list and campaign" />
    </div>
  );
};

export default ResultsPerListAndCampaign;
